<template>
  <div class="tabs-container">
    <DxTabs :data-source="tabs" :selected-index.sync="selectedIndex" @option-changed="onTabChanged"
      orientation="vertical" class="tabs" :item-template="tabTemplate" />
    <div v-if="selectedIndex === 0" class="tab-content">
      <GridIndustrii />
    </div>
    <div v-if="selectedIndex === 1" class="tab-content">
      <GridSalesSources />
    </div>
    <div v-if="selectedIndex === 2" class="tab-content">
      <GridZileDisponibilitate />
    </div>
    <div v-if="selectedIndex === 3" class="tab-content">
      <GridTipuriActivitati />
    </div>
    <div v-if="selectedIndex === 4" class="tab-content">
      <GridCampaniiMarketing />
    </div>
    <div v-if="selectedIndex === 5" class="tab-content">
      <v-row>
        <v-col cols="7">
          <GridTarget @selection-changed="handleSelectionChanged" />
        </v-col>
        <v-col cols="5">
          <GridTargetPeUser :TargetID="selectedRow" />
        </v-col>
      </v-row>
    </div>

  </div>
</template>

<script lang="ts">
import { DxTabs } from 'devextreme-vue/tabs';
import GridIndustrii from './GridIndustrii.vue'
import { DxPopup } from 'devextreme-vue/popup'
import GridSalesSources from './GridSalesSources.vue';
import GridZileDisponibilitate from './GridZileDisponibilitate.vue';
import GridTipuriActivitati from './GridTipuriActivitati.vue';
import GridCampaniiMarketing from './GridCampaniiMarketing.vue';
import GridTarget from './GridTarget.vue';
import GridTargetPeUser from './GridTargetPeUser.vue';
import GridShareAppointments from './GridShareAppointments.vue';


export default {
  components: {
    DxTabs,
    GridIndustrii,
    GridSalesSources,
    DxPopup,
    GridZileDisponibilitate,
    GridTipuriActivitati,
    GridCampaniiMarketing,
    GridTarget,
    GridTargetPeUser,
    GridShareAppointments
  },
  data() {
    return {
      tabs: [
        { text: 'Industrii' },
        { text: 'Surse de vânzare' },
        { text: 'Disponibilitate Zile' },
        { text: 'Tipuri Activități' },
        { text: 'Campanii Marketing' },
        { text: 'Target' },
        // { text: 'Share Appointments' },
      ],
      selectedIndex: 0,
      selectedRow: null as any,
    };
  },
  methods: {
    onTabChanged(e) {
      this.selectedIndex = e.component.option('selectedIndex');
    },
    tabTemplate(itemData, itemIndex, itemElement) {
      return `<div>${itemData.text}</div>`;
    },
    handleSelectionChanged(selectedRow: any) {
      this.selectedRow = selectedRow.ID;
    },
  },
};
</script>

<style scoped>
.tabs-container {
  display: flex;
  height: 100%;
}

.tabs {
  width: 200px;
  /* Adjust as needed */
  border-right: 1px solid #ddd;
  background-color: #f4f4f4;
}

.tab-content {
  flex: 1;
  padding: 16px;
  overflow: auto;
}

.tab-content>* {
  margin-bottom: 16px;
  /* Adjust spacing between components */
}
</style>
